import {
  ATMOrderPayment,
  TradeOrderStatus
} from "@foxone/api/src/models/market";

function _setPaying(vue: Vue, data) {
  vue.$store.commit("app/SET_PAYING", data);
}

async function _pullOrderResult(vue: Vue, id: string, callback: Function) {
  _setPaying(vue, { visible: true });
  const order = await vue.$api.market.getTradeOrderById(id);
  if (order.status === TradeOrderStatus.PENDING) {
    const timer = setTimeout(() => {
      _pullOrderResult(vue, id, callback);
    }, 3000);
    _setPaying(vue, { timer });
  } else {
    _setPaying(vue, { visible: false });
    if (callback && typeof callback === "function") {
      vue.$common.utils.helper.toast(vue, {
        message: vue.$t("common.payment.success") as string,
        color: "success"
      });
      callback(order);
    }
  }
}

function payment(
  vue: Vue,
  payment: ATMOrderPayment,
  id: string,
  callback: Function
) {
  const url = vue.$common.utils.helper.genPayment({
    amount: payment.amount,
    memo: payment.memo,
    assetId: payment.asset_id,
    recipient: payment.recipient,
    traceId: payment.trace_id
  });
  window.location.href = url;
  _pullOrderResult(vue, id, callback);
}

function showKycErrorModal(vue: Vue) {
  vue.$common.utils.helper.message(
    vue,
    {
      title: vue.$t("trade.c2c.otc-kyc-error-title") as string,
      description: vue.$t("trade.c2c.otc-kyc-error-description") as string,
      ok: vue.$t("trade.c2c.to-kyc") as string
    },
    {
      onOK: () => {
        vue.$helper.toFusionPath(vue, "basis", { name: "kyc" });
      }
    }
  );
}

export default {
  payment,
  showKycErrorModal
};
